export default __webpack_public_path__ + "staticlp1/media/banner-home-logado-1.9d4d4c27.png";